<template>
  <page-layout
    content-max-width="1680px"
    :title="courseTitle"
    :icon-config="{
      url: '',
      iconName: 'iconfont iconlogo',
      style: { fontSize: '28px', color: '#D71533' },
      isImg: false,
      isOfficial: true
    }"
    :vipTipShow="vipTipShow"
    showCompany
  >
    <div class="home-page-tabs" slot="custom-header">
      <div
        v-for="tabText in tabs"
        :key="tabText"
        class="home-page-tab-item"
        :class="tabActive === tabText && 'is-active'"
        @click="tabActive = tabText"
      >
        <span>{{ tabText }}</span>
      </div>
    </div>
    <div class="home-layout">
      <div class="course-panel" v-show="tabActive === '我的研究课题'">
        <div class="course-filter-content twin-content" ref="courseFilterRef">
          <el-input
            class="twin-input"
            v-model="courseFilterKeyword"
            placeholder="请输入关键词查找..."
            @keyup.enter.native="refreshCourseList()"
          />
          <el-button class="twin-btn" type="primary" @click="refreshCourseList()">
            <span>搜索</span>
          </el-button>
        </div>

        <h3 class="content-title">
          <span>我的研究课题</span>
        </h3>
        <div class="course-list" v-loading="coursePageInfo.loading > 0">
          <div class="course-list-item course-item" @click="createNewCourse()">
            <div class="add-course">
              <i class="el-icon-plus icon-btn"></i>
            </div>
            <div class="course-title-text create-text single-ellipsis">创建新课题</div>
          </div>
          <div
            class="course-list-item course-item"
            v-for="item in myCourseList"
            :key="item._id"
            @click="editCourseHandle(item)"
          >
            <div class="chart-preview">
              <div class="free-course" :style="{ background: '#FFBD53', color: '#fff' }" v-if="isExpire(item)">
                <span>已过期</span>
              </div>
              <div class="free-course" v-else-if="item._source.versionLevel === 0">
                <span>试用版课题</span>
              </div>
              <div class="tool-content">
                <div class="mask"></div>
                <el-button
                  class="renew-btn"
                  type="primary"
                  size="mini"
                  v-if="isExpire(item) && item._source.versionLevel === 1 && item._source.userId === userInfo.id"
                  @click.stop="renewHandle(item)"
                >
                  <span>立即续费</span>
                </el-button>
                <div class="tool-ul">
                  <el-tooltip effect="dark" content="修改课题名称" placement="top">
                    <i
                      class="iconfont iconbianji tool-icon"
                      @click.stop="titleEditor.showFunc(item, 'updateTitle')"
                    ></i>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="复制课题" placement="top" v-if="false">
                    <i class="iconfont iconfuzhi tool-icon" @click.stop="titleEditor.showFunc(item, 'copy')"></i>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="删除课题" placement="top">
                    <i class="iconfont iconshanchu tool-icon" @click.stop="delCourseHandle(item)"></i>
                  </el-tooltip>
                </div>
              </div>
              <img v-if="!item._source.chartType" :src="courseEmpty" alt="" class="course-chart-img empty" />
              <img v-else :src="chartImg[`${item._source.chartType}Img`]" alt="" class="course-chart-img" />
            </div>
            <div class="course-title-text">
              <el-popover trigger="hover" placement="bottom-start">
                <div class="normal-popover-content">{{ item._source.title }}</div>
                <div class="title-content had-tool-btn single-ellipsis" slot="reference">{{ item._source.title }}</div>
              </el-popover>
              <el-popover trigger="hover" placement="bottom-start">
                <div class="normal-popover-content">{{ fetchCourseRoleImg(item).desc }}</div>
                <img :src="fetchCourseRoleImg(item).img" alt="" class="course-role-img" slot="reference" />
              </el-popover>
            </div>
          </div>
        </div>
        <el-pagination
          class="course-pagenation normal-pagination"
          background
          @size-change="refreshCourseList()"
          @current-change="fetchCourseList()"
          :current-page.sync="coursePageInfo.page"
          :page-sizes="[12, 24, 48]"
          :page-size.sync="coursePageInfo.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="coursePageInfo.total"
        />
      </div>

      <div class="course-panel" v-if="commonCourseList.length > 0" v-show="tabActive === '我的研究课题'">
        <h3 class="content-title">示例课题</h3>
        <div class="course-list">
          <div
            class="course-list-item course-item"
            v-for="item in commonCourseList"
            :key="item._id"
            @click="editCourseHandle(item)"
          >
            <div class="chart-preview">
              <div class="tool-content">
                <div class="mask"></div>
                <div class="tool-ul" v-if="$store.getters.isAdmin">
                  <el-tooltip effect="dark" content="修改课题名称" placement="top">
                    <i
                      class="iconfont iconbianji tool-icon"
                      @click.stop="titleEditor.showFunc(item, 'updateTitle')"
                    ></i>
                  </el-tooltip>
                  <!-- <el-tooltip effect="dark" content="复制课题" placement="top">
                    <i class="iconfont iconfuzhi tool-icon" @click.stop="titleEditor.showFunc(item, 'copy')"></i>
                  </el-tooltip>
                  <el-tooltip effect="dark" content="删除课题" placement="top">
                    <i class="iconfont iconshanchu tool-icon" @click.stop="delCourseHandle(item._id)"></i>
                  </el-tooltip> -->
                </div>
              </div>
              <img v-if="!item._source.chartType" :src="courseEmpty" alt="" class="course-chart-img empty" />
              <img v-else :src="chartImg[`${item._source.chartType}Img`]" alt="" class="course-chart-img" />
            </div>
            <div class="course-title-text">
              <el-popover trigger="hover" placement="bottom-start">
                <div class="normal-popover-content">{{ item._source.title }}</div>
                <div class="title-content single-ellipsis" slot="reference">{{ item._source.title }}</div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>

      <div class="course-panel" v-show="['新手必修课', '示范课'].includes(tabActive)">
        <div v-for="(list, type) in curHelpVideoGroup" :key="type">
          <h3 class="content-title">{{ type }}</h3>
          <div class="course-list">
            <div class="course-list-item course-item" v-for="(item, index) in list" :key="index">
              <div class="chart-preview" @click="playVideoHandle({ ...item, url: item.link })">
                <div class="tool-content">
                  <div class="mask"></div>
                  <img class="play-btn" :src="playImg" />
                </div>
                <img :src="item.img_link" class="course-chart-img" />
              </div>
              <div class="course-title-text">
                <el-popover trigger="hover" placement="bottom-start">
                  <div class="normal-popover-content">{{ item.title }}</div>
                  <div class="title-content single-ellipsis" slot="reference">{{ item.title }}</div>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="course-panel" v-if="['实务文章', '操作指南查阅'].includes(tabActive)">
        <h3 class="content-title">{{ tabActive }}</h3>
        <articleList :key="tabActive" :type="tabActive" />
      </div>
    </div>

    <el-dialog
      class="create-dialog"
      :class="tipShow ? 'hide' : ''"
      width="900px"
      v-if="newCourseDialog"
      :visible="newCourseDialog"
      @close="closeCourseCreater()"
      :custom-class="`normal-dialog ${nextStep ? 'full-dialog' : ''}`"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div class="course-dialog-header" slot="title">
        <div class="header-step-content">
          <course-creater-header-step :active="nextStep ? 1 : 0" />
        </div>
        <div
          class="video-help"
          @click="
            playVideoHandle({
              url: 'http://www.xiaobaogong.com/audio/课题筛选弹框/如何创建新课题.mp4',
              title: '如何创建新课题？'
            })
          "
        >
          <i class="iconfont iconbofang-mian play-icon"></i>
          <span>帮助视频</span>
        </div>
      </div>
      <template v-if="!nextStep">
        <div class="newCourse-panel" :style="nextStep ? 'margin-top: 0 ' : ''">
          <div class="newCourse-panel-item">
            <img class="title-icon" :src="courseTitleImg" />
            <el-input
              placeholder="请输入课题名称"
              ref="courseName"
              :style="{ fontSize: '16px' }"
              :maxlength="100"
              v-model="courseModel.title"
              @keyup.enter.native="() => (courseModel.title ? (nextStep = true) : '')"
            ></el-input>
          </div>
        </div>
        <span slot="footer">
          <el-button
            :style="{ marginRight: '20px' }"
            type="primary"
            :disabled="!courseModel.title"
            @click="nextStep = true"
            >下一步，筛选数据</el-button
          >
        </span>
      </template>
      <template v-else>
        <course-filter
          ref="courseFilter"
          @saveCoursewareHandle="saveCoursewareHandle"
          @tipShowHandle="val => (tipShow = val)"
        ></course-filter>
      </template>
    </el-dialog>

    <video-player v-if="videoModel.show" :show.sync="videoModel.show" :info="videoModel.info" />

    <course-title-editor
      v-if="titleEditor.show"
      :show.sync="titleEditor.show"
      :title="`${titleEditor.action === 'copy' ? '输入新' : '修改'}课题名称`"
      :defaultTitleVal="titleEditor.value"
      :loading="titleEditor.loading"
      @confirm="val => (titleEditor.action === 'copy' ? copyCourseHandle(val) : updCourseTitleHandle(val))"
    />

    <el-dialog
      :visible="addInfoVisiable"
      :show-close="false"
      width="500px"
      custom-class="normal-dialog full-dialog info-dialog hide-header-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="info-panel">
        <div class="info-img">
          <img :src="infoHeadImg" />
        </div>
        <div class="info-img-desc">
          <h3>完善资料<span>免费试用</span></h3>
          <p class="word-middle">享受前所未有的法律科研新体验</p>
        </div>

        <div class="info-form">
          <el-form @submit.native.prevent label-position="top">
            <el-form-item v-if="!userInfo.tel">
              <span slot="label" class="word-normal">手机号<span :style="{ color: '#F62733' }">*</span></span>
              <el-input placeholder="请输入手机号" :maxlength="11" v-model="model.tel"></el-input>
            </el-form-item>
            <el-form-item v-if="!userInfo.tel">
              <span slot="label" class="word-normal">验证码 <span :style="{ color: '#F62733' }">*</span></span>
              <el-input placeholder="请输入验证码" :maxlength="6" v-model="model.validCode">
                <template slot="append">
                  <a
                    :style="{ color: '#1991FB', cursor: !disabled ? 'pointer' : 'inherit' }"
                    :disabled="disabled"
                    @click="getSmsCode"
                    >{{ verification }}</a
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item v-if="!userInfo.name">
              <span slot="label" class="word-normal">姓名<span :style="{ color: '#F62733' }">*</span></span>
              <el-input placeholder="请填写姓名" v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item v-if="!userInfo.org">
              <span slot="label" class="word-normal">机构<span :style="{ color: '#F62733' }">*</span></span>
              <el-input placeholder="请填写机构名称（例如学校、研究所、企业）" v-model="model.org"></el-input>
            </el-form-item>
            <el-form-item v-if="!userInfo.profession">
              <span slot="label" class="word-normal">职业 <span :style="{ color: '#F62733' }">*</span></span>
              <el-input placeholder="请输入职业" v-model="model.profession"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addInfoHandle" :style="{ width: '100%' }">立即试用</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <course-renew-dialog
      v-if="renewModal.show"
      :show.sync="renewModal.show"
      :detail="renewModal.detail"
      @success="renewSuccessHandle"
    />
  </page-layout>
</template>

<script>
import videoPlayer from '@/components/videoPlayer';
import courseFilter from '@/components/courseFilter';
import courseTitleEditor from '@/components/courseTitleEditor';
import courseCreaterHeaderStep from '@/components/courseCreater/courseCreaterHeaderStep';
import courseRenewDialog from '@/components/courseRenewDialog';
import articleList from './components/articleList.vue';

import { services } from '@/service';
import { formatChartInfo } from '@/lib/utils';
import courseEmpty from '@/assets/img/courseEmpty.png';
import lineChartImg from '@/assets/img/chartPreview/lineChart.png';
import lineChart2Img from '@/assets/img/chartPreview/lineChart2.png';
import barChartImg from '@/assets/img/chartPreview/barChart.png';
import barXChartImg from '@/assets/img/chartPreview/barXChart.png';
import pieChartImg from '@/assets/img/chartPreview/pieChart.png';
import pieChart2Img from '@/assets/img/chartPreview/pieChart2.png';
import numChartImg from '@/assets/img/chartPreview/numChart.png';
import tableChartImg from '@/assets/img/chartPreview/tableChart.png';
import courseTitleImg from '@/assets/img/courseTitle.png';
import tableAnalysisChartImg from '@/assets/img/chartPreview/tableAnalysisChart.png';
import infoHeadImg from '@/assets/img/info-head.png';
import { chartDefaultConfig } from '@/constantEnum';
import { maxBy, uniqBy, groupBy } from 'lodash';
import playImg from '@/assets/img/playImg.png';
import courseOwnerImg from '@/assets/img/课题管理员.png';
import courseMemberImg from '@/assets/img/课题协作者.png';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  components: { videoPlayer, courseFilter, courseTitleEditor, courseCreaterHeaderStep, courseRenewDialog, articleList },
  data() {
    return {
      playImg,
      tipShow: false,
      courseEmpty,
      chartImg: {
        lineChart2Img,
        pieChart2Img,
        lineChartImg,
        barChartImg,
        barXChartImg,
        pieChartImg,
        numChartImg,
        tableChartImg,
        tableAnalysisChartImg
      },
      courseTitleImg,
      infoHeadImg,
      newCourseDialog: false,
      courseModel: {
        title: '',
        userId: ''
      },
      courseModelLoading: false,
      videoModel: {},
      titleEditor: {
        show: false,
        action: '', // copy / updateTitle
        loading: false,
        value: '',
        courseDetail: null,
        showFunc: function(item, action) {
          this.action = action;
          this.loading = false;
          if (action === 'copy') {
            this.value = `${item._source.title} copy`;
          }
          if (action === 'updateTitle') {
            this.value = item._source.title;
          }
          this.courseDetail = item;
          this.show = true;
        }
      },
      nextStep: false,
      addInfoVisiable: false,
      isSendCode: false,
      verification: '获取验证码',
      disabled: false,
      model: {},
      vipTipShow: false,
      renewModal: {
        show: false,
        detail: null
      },
      tabActive: '我的研究课题',
      helpVideoGroups: {},
      myCourseList: [],
      commonCourseList: [],
      courseFilterKeyword: '',
      coursePageInfo: {
        page: 1,
        size: 24,
        total: 0,
        loading: 0
      }
    };
  },
  created() {
    if (this.$route.query.show_create) {
      this.createNewCourse();
    }
  },
  mounted() {
    if (!this.userInfo.name) {
      this.addInfoVisiable = true;
      this.model = { ...this.userInfo };
      return;
    }
    this.fetchData();
    this.initHandle();
  },
  computed: {
    ...mapGetters(['userInfo']),
    courseTitle() {
      return '小包公 · 法律实证分析平台';
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    tabs() {
      return ['我的研究课题', '新手必修课', '示范课', '实务文章', '操作指南查阅'];
    },
    curHelpVideoGroup() {
      return this.helpVideoGroups[this.tabActive] || {};
    }
  },
  methods: {
    async initHandle() {
      try {
        const typenames = ['新手必修课', '示范课'];

        let result = await services.courseware.getCourseCrime({
          size: 5000,
          query: { bool: { must: [{ terms: { 'typename.keyword': typenames } }] } },
          sort: [{ sort: 'desc' }]
        });

        result = result.hits.hits.map(item => item._source);

        result.forEach(i => {
          if (i.img_link && i.img_link.indexOf('http') === -1) {
            i.img_link = `${window.location.protocol}//${window.location.host}${i.img_link}`;
          }
          if (i.link && i.link.indexOf('http') === -1 && i.link.slice(0, 2) !== '//') {
            i.link = `${window.location.protocol}//${window.location.host}${i.link}`;
          }
        });

        const helpVideoGroups = {};

        typenames.forEach(typename => {
          helpVideoGroups[typename] = groupBy(
            result.filter(o => o.typename === typename),
            'category'
          );
        });

        this.helpVideoGroups = helpVideoGroups;
      } catch (err) {
        this.$error(err);
      }
    },
    fetchCourseRoleImg(item) {
      if (this.userInfo.id === item._source.userId) {
        return { img: courseOwnerImg, desc: '课题管理员' };
      }
      return { img: courseMemberImg, desc: '协作课题' };
    },
    isExpire(item) {
      if (!item._source.expirationTime) {
        return false;
      }
      return dayjs().isAfter(dayjs(item._source.expirationTime));
    },
    renewSuccessHandle() {
      this.fetchCourseList();
    },
    renewHandle(item) {
      this.renewModal = {
        show: true,
        detail: item
      };
    },
    async fetchData() {
      try {
        const [commonCourseResult, haveCourse] = await Promise.all([
          services.courseware.fetchCoursewareList({ page: 0, size: 50, type: '示例课题' }),
          services.courseware.getOwnerCourseCount(),
          this.fetchCourseList()
        ]);
        this.commonCourseList = commonCourseResult.data;
        this.vipTipShow = !haveCourse;
      } catch (err) {
        this.$error(err);
      }
    },
    refreshCourseList() {
      this.coursePageInfo.page = 1;
      this.coursePageInfo.total = 0;
      this.myCourseList = [];
      this.fetchCourseList();

      this.$nextTick(() => {
        const courseFilterRef = this.$refs.courseFilterRef;
        if (courseFilterRef) {
          courseFilterRef.scrollIntoView({ block: 'end' });
        }
      });
    },
    async fetchCourseList() {
      try {
        this.coursePageInfo.loading++;

        const params = { page: this.coursePageInfo.page - 1, size: this.coursePageInfo.size, type: '实证分析' };
        if (this.courseFilterKeyword.trim()) {
          params.title = this.courseFilterKeyword.trim();
        }
        const { data, total } = await services.courseware.fetchCoursewareList(params);
        this.myCourseList = data;
        this.coursePageInfo.total = total;
      } catch (err) {
        this.$error(err);
      } finally {
        this.coursePageInfo.loading--;
      }
    },
    closeCourseCreater() {
      if (!this.courseModelLoading) {
        this.newCourseDialog = false;
      }
    },
    createNewCourse() {
      this.courseModel = {
        title: '',
        userId: this.$store.getters.userInfo.id
      };
      this.nextStep = false;
      this.newCourseDialog = true;
      this.$nextTick(() => {
        this.$refs.courseName.focus();
      });
    },
    async delCourseHandle(courseDetail) {
      await new Promise((resolve, reject) => {
        this.$prompt('请输入该课题的名称来确认删除，删除课题之后将无法找回，请谨慎操作', '删除课题', {
          customClass: 'prompt-delete-dialog',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          inputValidator: val => val === courseDetail._source.title,
          inputPlaceholder: '请输入课题名称',
          inputErrorMessage: '请输入正确的课题名称后再删除'
        })
          .then(resolve)
          .catch(reject);
      });
      try {
        await services.courseware.delCourseware(courseDetail._id, {
          ...courseDetail._source,
          is_delete: 1
        });
        this.fetchCourseList();
        this.$message.success('课题删除成功');
      } catch (err) {
        this.$error(err);
      }
    },
    async fetchDefaultFields({ query, orderId, instrumentType }) {
      // 获取默认列头
      const defaultCourseInfo = await services.originCase.createCourseBasicInfo({
        title: this.courseModel.title,
        userId: this.$store.getters.userInfo.id,
        query: query,
        orderId: orderId,
        instrumentType
      });

      let { show_fields: defaultColumns = [], data = [], course_id: courseId } = defaultCourseInfo;
      const [allFieldByRelation, courseUnitGroups] = await Promise.all([
        services.courseware.getFields(courseId),
        services.courseware.getCourseUnitGroups(courseId)
      ]);

      let relationFilterVal = 'case';
      let relationFilterName = '';
      const relationUnitGroup = courseUnitGroups.find(o => o.id === relationFilterVal);
      if (!relationUnitGroup) {
        relationFilterVal = '';
      } else {
        relationFilterName = relationUnitGroup.name;
      }

      defaultColumns = defaultColumns
        .map(fieldName => {
          return allFieldByRelation.find(subItem => subItem.columnKey === fieldName);
        })
        .filter(item => !!item);
      const defaultFields = [...defaultColumns];

      const charts = [];
      data.forEach((dataItem, dataIndex) => {
        const { rows, columns, statistics, title, type, conditionTemp } = formatChartInfo({
          params: dataItem.params,
          allFieldByRelation
        });
        let chartHeight = 1200;
        if (type === 'numChart') {
          chartHeight = 800;
        }
        const chartFieldIds = [...defaultFields, ...rows, ...columns, ...statistics]
          .map(item => {
            if (item.isStatistic) {
              return item.fieldDetail.columnKey || item.fieldDetail.field_name;
            }
            return item.columnKey || item.field_name;
          })
          .filter(id => !!id);
        const chartFields = [...new Set(chartFieldIds)]
          .map(id => allFieldByRelation.find(subItem => subItem.columnKey === id))
          .filter(item => !!item);
        defaultColumns.push(...chartFields);
        // 对应researchCreater组件创建时的对象
        charts.push({
          index_id: dataIndex,
          title,
          conditionTemp,
          rows,
          columns,
          statistics,
          dataSet: JSON.stringify({}),
          height: chartHeight,
          width: 1200,
          size: 'middle',
          type,
          fields: chartFields,
          chartConfig: chartDefaultConfig[type],
          historyList: '[]',
          relationFilterVal,
          relationFilterName
        });
      });

      defaultColumns = uniqBy(
        defaultColumns.filter(item => !!item),
        '_id'
      );

      return { defaultFields: defaultColumns, charts, courseId };
    },
    async updCourseTitleHandle(title) {
      try {
        this.titleEditor.loading = true;
        const item = this.titleEditor.courseDetail;
        await services.courseware.saveCourseware(item._id, { ...item._source, title });
        const index = this.myCourseList.findIndex(courseItem => courseItem._id === item._id);
        if (index > -1) {
          this.myCourseList.splice(index, 1, {
            ...item,
            _source: {
              ...item._source,
              title
            }
          });
        }
        this.titleEditor.show = false;
        this.$message.success(`课题标题修改成功`);
      } catch (err) {
        this.$error(err);
      } finally {
        this.titleEditor.loading = false;
      }
    },
    async copyCourseHandle(title) {
      console.log(title);
    },
    async saveCoursewareHandle({ orderId, callback, query, condition, instrumentType = '裁判文书' }) {
      try {
        this.courseModelLoading = true;

        const { title, userId } = this.courseModel;

        const { defaultFields, charts = [], courseId } = await this.fetchDefaultFields({
          query: query.query,
          orderId,
          instrumentType
        });

        await services.courseware.saveCourseware(courseId, {
          title,
          userId,
          fields: defaultFields,
          dataSource: JSON.stringify(query),
          condition: JSON.stringify(condition),
          historyList: '[]',
          chart: charts,
          instrumentType
        });
        services.logger.handleLog({
          operateName: '创建课题',
          toPathName: 'researchDashboard',
          apiUrl: '/nlp/es/save',
          otherParams: { info: [title] }
        });
        this.courseModelLoading = false;
        this.$refs.courseFilter.saveCoursewareLoading = false;
        this.closeCourseCreater();
        callback({ isSuccess: true });
        this.$router.push({
          path: '/research-dashboard',
          query: {
            courseware_id: courseId
          }
        });
      } catch (err) {
        callback({ isFail: true });
        this.courseModelLoading = false;
        this.$refs.courseFilter.saveCoursewareLoading = false;
        this.$error(err);
      }
    },
    editCourseHandle(item) {
      this.$router.push({
        path: '/research-dashboard',
        query: {
          courseware_id: item._id
        }
      });
    },
    playVideoHandle(item) {
      this.videoModel = {
        show: true,
        info: {
          url: item.url,
          title: item.title,
          pageTitle: '首页'
        }
      };
    },
    fetchPreviewType(chart) {
      let newUpdateChart = null;

      chart.forEach(chartItem => {
        const newHistoryItem = JSON.parse(chartItem.historyList || '[]')[0];
        if (!newHistoryItem) {
          return;
        }
        const updateTime = Number(String(newHistoryItem.dateTime).split('_')[0]);
        if (!newUpdateChart || updateTime > newUpdateChart.updateTime) {
          newUpdateChart = { ...chartItem, updateTime };
        }
      });

      if (!newUpdateChart) {
        return maxBy(chart, 'index_id').type;
      } else {
        return newUpdateChart.type;
      }
    },
    async getSmsCode() {
      try {
        if (!this.model.tel) {
          this.isSendCode = true;
          this.$message({ type: 'warning', message: '请输入正确的手机号码' });
          return;
        }
        if (this.verification !== '重新发送' && this.verification !== '获取验证码') {
          return;
        }
        if (this.disabled) {
          return;
        }
        var time = 60;
        var timer = setInterval(() => {
          time--;
          this.verification = `${time}s`;
          if (time == 0) {
            clearInterval(timer);
            timer = null;
            this.verification = '重新发送';
            this.disabled = false;
          }
        }, 1000);

        this.disabled = true;
        await services.authriozation.getSmsCode({ tel: this.model.tel });
      } catch (err) {
        this.$error(err);
      }
    },
    async addInfoHandle() {
      if (!this.model.name) {
        this.$message({ type: 'warning', message: '请输入正确的姓名' });
        return;
      }

      if (!this.model.tel) {
        this.isSendCode = true;
        this.$message({ type: 'warning', message: '请输入正确的手机号码' });
        return;
      }

      if (this.isSendCode && !this.model.validCode) {
        this.$message({ type: 'warning', message: '请输入正确的验证码' });
        return;
      }

      if (!this.model.org) {
        this.$message({ type: 'warning', message: '请填写机构名称（例如学校、研究所、企业）' });
        return;
      }

      if (!this.model.profession) {
        this.$message({ type: 'warning', message: '请填写职业' });
        return;
      }

      try {
        await services.authriozation.setUserInfo(this.model);
        this.addInfoVisiable = false;
        await this.$store.dispatch('getUserInfo');
        this.fetchData();
      } catch (err) {
        this.$error(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  justify-content: center;
}
::v-deep .create-dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-dialog__footer {
    padding-top: 0;
    padding-bottom: 20px;
  }

  &.hide {
    .el-dialog {
      opacity: 0;
    }
  }

  .course-dialog-header {
    .title {
      font-size: 16px;
      line-height: 22px;
      color: #3d465a;
    }
    .tip {
      font-size: 12px;
      line-height: 17px;
      color: #9599a5;
      margin-top: 5px;
    }
    .video-help {
      position: absolute;
      top: 15px;
      right: 60px;
      color: #409eff;
      font-size: 12px;
      cursor: pointer;

      .play-icon {
        font-size: 12px;
        margin-right: 4px;
      }
    }
  }
}

.home-page-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  background-color: #fff;
  .home-page-tab-item {
    position: relative;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    color: #3d465a;
    margin: 0 20px;
    cursor: pointer;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: #1991fb;
      visibility: hidden;
    }

    &.is-active {
      color: #1991fb;
      &::after {
        visibility: visible;
      }
      & > span {
        font-weight: bold;
      }
    }
  }
}

.home-layout {
  padding: 0 60px 50px;

  .course-panel {
    .course-filter-content {
      width: 600px;
      margin: 20px auto -40px;
    }
    .course-pagenation {
      margin-top: 20px;
    }
    .course-list {
      width: calc(100% + 20px);
    }
    .course-list-item {
      position: relative;
      display: inline-block;
      width: 220px;
      margin-right: 20px;
      margin-top: 20px;
      background: #ffffff;
      box-shadow: 0px 2px 4px 2px rgb(129 150 180 / 16%);
      border-radius: 10px;
      cursor: pointer;
      transition: all 0.3s;
      overflow: hidden;

      .course-title-text {
        position: relative;
        box-sizing: border-box;
        display: inline-block;
        color: rgba(#2c3443, 0.8);
        font-size: 14px;
        width: 100%;
        padding: 10px 14px;

        .course-role-img {
          position: relative;
          top: 1px;
          height: 16px;
          margin-left: 4px;
        }

        &.create-text {
          position: relative;
          left: 50%;
          transform: translateX(-50%);
          padding-right: 14px;
          text-align: center;
        }

        .title-content {
          display: inline-block;
          max-width: 100%;

          &.had-tool-btn {
            width: calc(100% - 25px);
          }
        }
      }

      &.course-item {
        &:hover {
          transform: translateY(-10px);
        }
      }
    }

    .add-course,
    .chart-preview {
      box-sizing: border-box;
      position: relative;
      width: 100%;
      height: 150px;
      border-bottom: 1px solid rgba(#e9ebf1, 0.5);

      .free-course {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 12px;
        height: 24px;
        padding: 0 8px;
        line-height: 24px;
        color: #3d465a;
        background-color: #eaf6ff;
        border-bottom-right-radius: 10px;
        z-index: 1;
      }

      .course-chart-img {
        position: relative;
        left: 50%;
        top: 50%;
        width: 100%;
        transform: translate(-50%, -50%);

        &.empty {
          width: 160px;
        }
      }

      .tool-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        z-index: 2;
        .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(#000, 0.2);
          z-index: 1;
        }
        .renew-btn {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 2;
        }
        .tool-ul {
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 2;
          .tool-icon {
            font-size: 14px;
            color: #fff;
            padding: 5px;
          }
        }
        .play-btn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 36px;
          z-index: 2;
        }
      }

      &:hover {
        .tool-content {
          opacity: 1;
        }
      }
    }
    .add-course {
      display: flex;
      justify-content: center;
      align-items: center;

      .icon-btn {
        color: #0c93f2;
        font-size: 24px;
      }
    }
    .content-title {
      position: relative;
      font-size: 16px;
      padding-left: 15px;
      margin-top: 40px;
      color: #2c3443;
      display: flex;
      align-items: flex-start;
      &::after {
        content: '';
        display: inline-block;
        position: absolute;
        width: 3px;
        height: 20px;
        background: #409eff;
        left: 0;
        top: -2px;
        border-radius: 26%;
      }

      .limit-tip {
        position: relative;
        top: -2px;
        height: 100%;
        font-size: 12px;
        padding-bottom: 4px;
        margin-left: 20px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .tip-text {
          margin-right: 40px;
        }
        .buy-btn {
          color: #409eff;
          cursor: pointer;
        }

        .progress-content {
          position: absolute;
          width: 100%;
          height: 3px;
          bottom: -4px;
          left: 0;
        }
      }
    }
  }
}
.newCourse-panel {
  margin: 20px;
  &-item {
    position: relative;
    border-bottom: 2px solid #d9dde4;
    padding-bottom: 15px;
    padding-left: 20px;
    ::v-deep .el-input {
      input {
        border: 0;
        padding: 5px 10px;
      }
    }

    .title-icon {
      position: absolute;
      top: 7px;
      left: 0;
      width: 20px;
    }
  }

  .radio-content {
    margin: 20px 0 10px;

    .radio-item {
      display: block;
      margin-bottom: 6px;

      .mode-item {
        display: inline-block;
        font-size: 14px;
        line-height: 22px;
        .mode-tip {
          font-weight: 300;
          font-size: 12px;
          color: #77839e;
        }
      }
    }
  }

  .mode-pick-tip {
    color: #77839e;
    font-size: 12px;
    line-height: 17px;

    & > span {
      font-weight: 300;
    }
  }
}

.info-panel {
  .info-img {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      display: block;
    }
  }

  .info-img-desc {
    position: absolute;
    left: 30px;
    top: 40px;
    color: #fff;
    line-height: 32px;
    h3 {
      font-size: 22px;
      font-weight: 300;
    }
  }
  .info-form {
    padding: 30px;
    background: #fff;
  }
}
</style>
